<template>
    <div class="columns">
        <section class="section column is-2 menu-background">
            <Menu />
        </section>
        <section class="column is-10">

            <div class="navbar-custom-pc">
                <NavBar />
            </div>
            <div class="column is-10">
                <figure class="image" >
                    <img src="../assets/logo.png" alt="">
                </figure>
            </div>

        </section>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Menu from '@/components/Menu.vue'

export default {
  name:'PageNotFound',
    data()    {
        return {

        }
    },
    components:{
        NavBar,
        Menu
    },
    
}
</script>